module.exports = __webpack_public_path__ + "static/media/ne.3d8e6ffb.svg";